import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12,6.58A1.48,1.48,0,0,0,10.93,7L2.3,15.65a1,1,0,1,0,1.48,1.47L12,8.9l8.22,8.22a1,1,0,0,0,1.47-1.47L13.06,7A1.46,1.46,0,0,0,12,6.58Z" }));
export default SvgArrowUp;
